<template>
  <b-container fluid>
    <div class="page-header">
      <div class="col-md-6">
        <h1>
          Contract
          <small>
            #{{ uuid }}
          </small>
        </h1>
      </div>
    </div>

    <div class="col-md-12">
      <div v-for="assignmentTerm in assignmentTerms" :key="assignmentTerm.id">
        <AssignmentTermItem v-bind="assignmentTerm"/>
      </div>
    </div>
  </b-container>
</template>

<script>

import AssignmentTermItem from '@/components/AssignmentTermItem'
import AssignmentTermsProvider from '@/services/AssignmentTermsProvider'

export default {
  name: 'ContractDetails',
  components: {
    AssignmentTermItem
  },
  data () {
    return {
      uuid: null,
      assignmentTerms: []
    }
  },
  mounted () {
    this.uuid = this.$route.params.uuid
    AssignmentTermsProvider.all({ contractId: this.$route.params.uuid })
      .then((resp) => {
        this.assignmentTerms = resp.body.assignment_terms
      })
  }
}
</script>

<style scoped>
</style>
